<template>
  <header class="page-company-header">
    <!-- Content -->
    <div class="row-1 page-company-header__content p-top-3 p-bot-3">
      <!-- Title -->
      <div class="page-company-header__content__title m-bot-4">
        <h1
          data-animate="header-title"
          v-if="props.company.generalHeader?.[0]?.generalHeaderTitle"
          class="title-l page-company-header__title"
        >
          {{ props.company.generalHeader?.[0]?.generalHeaderTitle }}
        </h1>
        <div
          v-if="props.company.generalHeader?.[0]?.generalHeaderText"
          data-animate="header-content"
          class="page-company-header__text text-l m-top-6"
          v-html="props.company.generalHeader?.[0]?.generalHeaderText"
        />
      </div>
    </div>

    <!-- Picture -->
    <div class="page-company-header__image" data-animate="header-image">
      <WidgetPicture
        :image="{
          custom: props.company.generalCover?.[0],
        }"
        v-anim-parallax-element="{
          target: 'picture',
        }"
        :alt="props.company.generalCover?.[0]?.title"
      />
    </div>
  </header>
</template>

<script>
export default {
  name: 'PagesCompanyHeader',
}
</script>

<script setup>
const props = defineProps({
  company: Object,
})
</script>

<style lang="scss">
@import './style.scss';
</style>
